'use strict';

import AxiosService from '../AxiosService';
import { default as Store, LOGGED_IN } from '../../store';

const USER_ENDPOINT = "/api/v1/user"

export default class UserService {

    constructor() {
        this.service = new AxiosService();
    }

    getUserInfo() {
        const request = this.service.get(USER_ENDPOINT);
        request
            // error is not used, but don't know how to do it in a different way
            // eslint-disable-next-line
            .then(response => {
                Store.commit(LOGGED_IN, response.data);
            })
            // error is not used, but don't know how to do it in a different way
            // eslint-disable-next-line
            .catch(error => {
                window.location = "/oauth2/authorization/entra";
            });
    }
}